import { useRef, useState, useEffect } from "react";
import useDetectOutsideClick from "../hooks/useDetectOutsideClick";

const useOpacity = ({ DEFAULT_OPACITY }) => {
  const [opacityBtnStatus, setOpacityBtnStatus] = useState(true);
  const [opacityLayer, setOpacityLayer] = useState(DEFAULT_OPACITY);
  return {
    opacityBtnStatus,
    opacityLayer,
    setOpacityBtnStatus,
    setOpacityLayer,
  };
};

const DefaultSliderIcon = () => {
  return (
    <svg
      className="h-6 w-6"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
      />
    </svg>
  );
};

const OpacitySlider = ({
  onFinalChange,
  SliderIcon,
  btnStatus,
  defaultOpacity,
  tooltipFor,
}) => {
  const [sliderValue, setSliderValue] = useState();
  const opacitySliderRef = useRef();
  const sliderContainerRef = useRef();
  const [isActive, setIsActive] = useDetectOutsideClick(
    sliderContainerRef,
    false
  );

  const onRangerChange = () => {
    setSliderValue(Number(opacitySliderRef.current.value));
    onFinalChange(Number(opacitySliderRef.current.value));
  };

  useEffect(() => {
    setSliderValue(defaultOpacity);
  }, [defaultOpacity]);

  return (
    <div className="opacity-slider">
      <button
        className={`bg-white hover:bg-gray-100 text-gray-800 font-semibold py-1 px-1 border border-gray-400 rounded shadow ${
          btnStatus ? `opacity-50 cursor-not-allowed` : ""
        }`}
        onClick={() => {
          if (!isActive) {
            setIsActive(true);
            return;
          }
          setIsActive(false);
        }}
        disabled={btnStatus && true}
        data-tip
        data-for={tooltipFor}
      >
        {SliderIcon ? SliderIcon : <DefaultSliderIcon />}
      </button>
      <div
        key={`${Math.round(sliderValue)}_op`}
        ref={sliderContainerRef}
        className={`${
          !isActive ? `hidden` : `block`
        } absolute left-0 slide-up mt-10 p-2 rounded-lg shadow-lg border-2 bg-gray-300 border-blue-600 z-10 group-hover:block`}
      >
        <input
          ref={opacitySliderRef}
          type="range"
          orient="vertical"
          defaultValue={sliderValue === undefined ? 1 : sliderValue}
          min="0"
          max="1"
          step="0.1"
          className="input-vertical-range"
          onMouseUp={onRangerChange}
        />
      </div>
    </div>
  );
};

export { OpacitySlider, useOpacity };
